export default __webpack_public_path__ + "static/media/gallery-wip-denix-barrel_00.279f6fff.jpg";